// import React, { useState, useRef, useEffect } from "react";

// export default function SmartTextArea({
//   placeholder = "متنت رو بنویس...",
//   maxLength = 500,
// }) {
//   const [value, setValue] = useState("");
//   const [focused, setFocused] = useState(false);
//   const textareaRef = useRef(null);

//   // تنظیم خودکار ارتفاع بر اساس محتوای textarea
//   useEffect(() => {
//     const el = textareaRef.current;
//     if (el) {
//       el.style.height = "auto"; // ریست برای محاسبه دوباره
//       el.style.height = `${el.scrollHeight}px`; // تنظیم ارتفاع واقعی
//     }
//   }, [value]);

//   const isExpanded = focused || value.length > 0;

//   return (
//     <div
//       className={`transition-all duration-300 ease-in-out w-full max-w-xl mx-auto bg-white dark:bg-zinc-800 rounded-2xl border
//       ${focused ? "border-emerald-500 shadow-md" : "border-gray-300"}
//       ${isExpanded ? "p-3" : "p-2"}
//       `}
//     >
//       <textarea
//         ref={textareaRef}
//         value={value}
//         placeholder={placeholder}
//         maxLength={maxLength}
//         onChange={(e) => setValue(e.target.value)}
//         onFocus={() => setFocused(true)}
//         onBlur={() => setFocused(false)}
//         rows={1}
//         className={`w-full resize-none overflow-hidden bg-transparent outline-none text-gray-900 dark:text-gray-100 
//         placeholder-gray-400 transition-all duration-300
//         ${isExpanded ? "min-h-[60px]" : "h-[24px] text-sm"}
//         `}
//       />
//       <div className="flex justify-between items-center mt-1 text-xs text-gray-400">
//         <span>{value.length > 0 && `${value.length}/${maxLength}`}</span>
//       </div>
//     </div>
//   );
// }
// import React, { useState, useRef, useEffect } from "react";

// export default function SmartTextArea({
//   placeholder = "متنت رو بنویس...",
//   maxLength = 500,
//   maxHeight = 200,
// }) {
//   const [value, setValue] = useState("");
//   const [focused, setFocused] = useState(false);
//   const [collapsed, setCollapsed] = useState(true);
//   const textareaRef = useRef(null);

//   useEffect(() => {
//     const el = textareaRef.current;
//     if (!el) return;

//     el.style.height = "auto";
//     const scrollHeight = el.scrollHeight;
//     el.style.height = `${Math.min(scrollHeight, maxHeight)}px`;

//     // اگر ارتفاع از حد مجاز بیشتر شد، به پایین اسکرول کن
//     if (scrollHeight > maxHeight) el.scrollTop = el.scrollHeight;
//   }, [value, collapsed]);

//   // کنترل فوکوس و بلور
//   const handleFocus = () => {
//     setFocused(true);
//     setCollapsed(false);
//   };

//   const handleBlur = () => {
//     setFocused(false);
//     if (value.trim() === "") {
//       // اگه خالی بود، جمع بشه
//       setCollapsed(true);
//     } else {
//       // اگه متن داشت، باز هم جمع بشه و فقط یک خط با ... نشون بده
//       setCollapsed(true);
//     }
//   };

//   // تشخیص اینکه textarea جمع شده یا باز
//   const isCollapsed = collapsed && !focused;

//   return (
//     <div
//       className={`transition-all duration-300 ease-in-out w-full max-w-xl mx-auto bg-white dark:bg-zinc-800 rounded-2xl border
//       ${focused ? "border-emerald-500 shadow-md" : "border-gray-300"}
//       ${!isCollapsed ? "p-3" : "p-2"}
//       `}
//     >
//       <div className="relative">
//         <textarea
//           ref={textareaRef}
//           value={value}
//           placeholder={placeholder}
//           maxLength={maxLength}
//           onChange={(e) => setValue(e.target.value)}
//           onFocus={handleFocus}
//           onBlur={handleBlur}
//           rows={1}
//           className={`w-full resize-none overflow-hidden bg-transparent outline-none text-gray-900 dark:text-gray-100 
//           placeholder-gray-400 transition-all duration-300
//           ${isCollapsed ? "h-[28px] text-sm line-clamp-1" : ""}
//           `}
//           style={{
//             transition: "height 0.25s ease",
//             whiteSpace: isCollapsed ? "nowrap" : "pre-wrap",
//             overflow: isCollapsed ? "hidden" : "auto",
//             textOverflow: isCollapsed ? "ellipsis" : "unset",
//           }}
//         />
//       </div>
//       {!isCollapsed && (
//         <div className="flex justify-between items-center mt-1 text-xs text-gray-400">
//           <span>{value.length > 0 && `${value.length}/${maxLength}`}</span>
//         </div>
//       )}
//     </div>
//   );
// }
import React, { useState, useRef, useEffect } from "react";

export default function SmartTextArea({
    onChangeValue,
  placeholder = "درباره ی ابزار خود توضیح دهید.",
  maxLength = 500,
  maxHeight = 200, // حداکثر ارتفاع قبل از فعال شدن اسکرول
}) {
  const [value, setValue] = useState("");
  const [focused, setFocused] = useState(false);
  const [collapsed, setCollapsed] = useState(true);
  const textareaRef = useRef(null);

  useEffect(() => {
    const el = textareaRef.current;
    if (!el) return;

    // تنظیم ارتفاع تا زمانی که از maxHeight بیشتر نشده
    el.style.height = "auto";
    const scrollHeight = el.scrollHeight;
    el.style.height = `${Math.min(scrollHeight, maxHeight)}px`;

    // اگر متن بیشتر از maxHeight بود، اسکرول داخلی فعال بشه
    if (scrollHeight > maxHeight) {
      el.style.overflowY = "auto";
      el.scrollTop = el.scrollHeight; // اسکرول به پایین (برای دیدن آخر متن)
    } else {
      el.style.overflowY = "hidden";
    }
  }, [value, collapsed]);

  const handleFocus = () => {
    setFocused(true);
    setCollapsed(false);
  };

  const handleBlur = () => {
    setFocused(false);
    // در هر صورت وقتی فوکوس از بین بره، جمع می‌شه
    setCollapsed(true);
  };

  const isCollapsed = collapsed && !focused;
  const handleChange = (e) => {
    setValue(e.target.value);
    if (onChangeValue) onChangeValue(e.target.value); // ارسال value به پدر
  };
  return (
    <div
      className={`transition-all duration-300 ease-in-out w-full max-w-xl mx-auto bg-white rounded-lg border
      ${focused ? "border-[#FFC505] shadow-md" : "border-gray-300"}
      ${isCollapsed ? "h-[43px] text-sm text-center" : ""}
   
      `}
    >
      <textarea
        ref={textareaRef}
        value={value}
        placeholder={placeholder}
        maxLength={maxLength}
        onChange={handleChange}
        onFocus={handleFocus}
        onBlur={handleBlur}
        rows={1}
        className={`w-full resize-none bg-transparent outline-none text-gray-900 dark:text-gray-100 border-none 
        focus:border-0  focus:outline-none focus:ring-0 focus:shadow-none
          placeholder-gray-400 transition-all duration-300 placeholder:text-sm placeholder:text-right
          scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-transparent
          ${isCollapsed ? "h-[20px] text-sm " : ""}
          ${!isCollapsed ? "p-3" : "p-2"}
        `}
        style={{
          transition: "height 0.25s ease",
          whiteSpace: isCollapsed ? "nowrap" : "pre-wrap",
          overflow: isCollapsed ? "hidden" : "auto",
          textOverflow: isCollapsed ? "ellipsis" : "unset",
          scrollBehavior: "smooth",
        }}
      />

      {/* فقط وقتی بازه شمارنده نشون بده */}
      {/* {!isCollapsed && (
        <div className="flex justify-between items-center mt-1 text-xs text-gray-400">
          <span>{value.length > 0 && `${value.length}/${maxLength}`}</span>
        </div>
      )} */}
    </div>
  );
}
